// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2vZpZ","right":"Footer_right__2cscv","buttons":"Footer_buttons__1WXq3"};